export const ENVIRONMENTS_RESET_STATE = 'ENVIRONMENTS_RESET_STATE';
export const ENVIRONMENTS_CURRENT_ITEM = 'ENVIRONMENTS_CURRENT_ITEM';

export const ENVIRONMENTS_REQUEST_LOADING = 'ENVIRONMENTS_REQUEST_LOADING';
export const ENVIRONMENTS_REQUEST_SUCCESS = 'ENVIRONMENTS_REQUEST_SUCCESS';
export const ENVIRONMENTS_REQUEST_FAILED = 'ENVIRONMENTS_REQUEST_FAILED';

export const ENVIRONMENTS_CURRENT_ACTION = 'ENVIRONMENTS_CURRENT_ACTION';
export const ENVIRONMENTS_RESET_ACTION = 'ENVIRONMENTS_RESET_ACTION';